(function ($) {
  Drupal.behaviors.modalExample = {
    attach: function attach(context, settings) {
      // For z-indexes to display properly, move all modals to end of body tag.
      /*
      jQuery('.modal').each(function() {
        $(this).detach().appendTo('body');
      });
      // Show and hide modal
      jQuery('a[data-target]').on('click', function() {
        var targetId = $(this).attr('data-target');
        jQuery(targetId).show();
      });
      jQuery('button.close').on('click', function() {
        jQuery(this).parents('.modal').hide();
      });
      */
    }
  };
})(jQuery);
